var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-tabs',{class:_vm._.bar,attrs:{"sticky":!(
      _vm.bookGoodsModel.relatedCommodities &&
      _vm.bookGoodsModel.relatedCommodities.length
    ),"scrollspy":true}},[(!_vm.isCoupon && _vm.$slots.desc)?_c('van-tab',{attrs:{"title":"套餐详情"}},[_vm._t("desc")],2):_vm._e(),(_vm.$slots.notice)?_c('van-tab',{attrs:{"title":"购买须知"}},[_vm._t("notice")],2):_vm._e(),(_vm.$slots.comment)?_c('van-tab',{attrs:{"title":"网友点评"}},[_vm._t("comment")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }